import { render, staticRenderFns } from "./AliVerify.vue?vue&type=template&id=e067e852&"
import script from "./AliVerify.vue?vue&type=script&lang=js&"
export * from "./AliVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports